import React from "react";
import Header from "../partials/Header";
import Product from "../partials/Product";
import Footer from "../partials/Footer";

function Products() {
	return (
		<div className="flex flex-col min-h-screen overflow-hidden">
			{/*  Site header */}
			<Header />
			{/*  Page content */}
			<main className="flex-grow">
				{/*  Page sections */}
				<Product />
			</main>

			{/*  Site footer */}
			<Footer />
		</div>
	);
}

export default Products;
